import React, { useEffect } from 'react'
import StatsBox from '../StatsBox/StatsBox';
import { formatStringNumber } from '../../services/Helpers/fonctions';

function StatBoxVadis({ statsPaye , statsnonPaye}) {
 
  
  useEffect(() => {
 
  },[])  
  return (
    <>
        <div className="boxes">
            <StatsBox
                title={"Paiements effectués"}
                amount={ statsPaye ? formatStringNumber(statsPaye): 0 }
                link={"/ct/paiement/list"}
                position={1}
                stat={{ mode_paiement: "cash",}}
            />
            <StatsBox
                title={"Paiements non effectués"}
                amount={statsnonPaye ? formatStringNumber(statsnonPaye) : 0}
                link={"/ct/paiement/list"}
                position={1}
                stat={{ mode_paiement: "virement crédit",}}
            />
        </div>
   </> 
  )
}

export default StatBoxVadis;